// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InvoiceWhat_wrapper__GwIlJ","title":"InvoiceWhat_title__2Srfa"};